export default __webpack_public_path__ + "static/dot-grid-c18d167ec16747d50574f2a02b5307eb.png";